export const RESET = 'ui/RESET';
export const CHANGE_SCREEN = 'ui/CHANGE_SCREEN';
export const SET_CARD_READER_ZOOM_LEVEL = 'ui/SET_CARD_READER_ZOOM_LEVEL';
export const SET_CARD_POSITION = 'ui/SET_CARD_POSITION';
export const SET_FULL_SCREEN_MODE_ENABLED = 'ui/SET_FULL_SCREEN_MODE_ENABLED';
export const ANIMATE_TO_SCREEN = 'ui/ANIMATE_TO_SCREEN';
export const ANIMATE_TO_SCREEN_AND_BEEP = 'ui/ANIMATE_TO_SCREEN_AND_BEEP';

export const reset = () => ({ type: RESET });

export const animateToScreen = (screenName) => ({
  type: ANIMATE_TO_SCREEN,
  payload: screenName,
});

export const animateToScreenAndBeep = (screenName) => ({
  type: ANIMATE_TO_SCREEN_AND_BEEP,
  payload: screenName,
});

export const setCardReaderZoomLevel = (zoomLevel) => ({
  type: SET_CARD_READER_ZOOM_LEVEL,
  payload: zoomLevel,
});

export const setCardPosition = (position) => ({
  type: SET_CARD_POSITION,
  payload: position,
});

export const setFullScreenModeEnabled = (isFullScreenModeEnabled) => ({
  type: SET_FULL_SCREEN_MODE_ENABLED,
  payload: isFullScreenModeEnabled,
});
